(function () {
  if (window.__mvConversion) return;
  window.__mvConversion = true;

  /* ============ STAFFELKORTING (AAN) ============
     De 3 automatische kortingen bestaan in Shopify (2 items 10%, 3 items 15%, 4 items 20%).
     Zet BUNDLE_ENABLED op false om de regel op de productpagina en de balk in het mandje te verbergen.
     Voorbeeld: ?mv_bundle=1 forceert de weergave ook als de schakelaar uit staat. */
  var BUNDLE_ENABLED = true;
  var TIERS = [{ qty: 2, pct: 10 }, { qty: 3, pct: 15 }, { qty: 4, pct: 20 }];
  var bundlePreview = false;
  try {
    if (location.search.indexOf('mv_bundle=1') > -1) sessionStorage.setItem('mvBundle', '1');
    bundlePreview = sessionStorage.getItem('mvBundle') === '1';
  } catch (e) {}
  var bundleOn = BUNDLE_ENABLED || bundlePreview;

  var PROTECT_HANDLE = 'shipping-protection';

  var gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var tick = `<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6' aria-hidden='true'><path d='M5 12.5l4.5 4.5L19 7.5'/></svg>`;
  var tagIcon = `<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.4' aria-hidden='true'><path d='M3.5 12.5V4.5h8l9 9-8 8z'/><circle cx='8' cy='9' r='1.2'/></svg>`;
  var shield = `<svg class='mv-protect__icon' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.3' aria-hidden='true'><path d='M12 3l7.5 3v5.5c0 4.4-3 8.2-7.5 9.5C7.5 19.7 4.5 15.9 4.5 11.5V6z'/><path d='M8.7 12l2.4 2.4 4.3-4.6'/></svg>`;

  var css = `.mv-drawer-notes{list-style:none;margin:0 0 1.2rem;padding:0;font-size:1.2rem;letter-spacing:.03em;display:flex;flex-direction:column;gap:.5rem}.mv-drawer-notes li{display:flex;gap:.8rem;align-items:flex-start;line-height:1.4}.mv-drawer-notes svg{flex:0 0 1.4rem;width:1.4rem;height:1.4rem;margin-top:.1rem}.mv-upsell{padding:1.6rem 0 1rem;margin-top:1.2rem;border-top:1px solid rgba(58,40,29,.14)}.mv-upsell__title{font-size:1.1rem;letter-spacing:.22em;text-transform:uppercase;margin:0 0 1.2rem}.mv-upsell__item{display:grid;grid-template-columns:6.4rem 1fr auto;gap:1.2rem;align-items:center;padding:.8rem 0}.mv-upsell__item img{display:block;width:6.4rem;height:8rem;object-fit:cover;background:#f4efe9}.mv-upsell__name{display:block;font-size:1.2rem;letter-spacing:.08em;text-transform:uppercase;line-height:1.4;margin-bottom:.3rem;text-decoration:none}.mv-upsell__price{display:block;font-size:1.2rem;opacity:.8}.mv-upsell select{margin-top:.6rem;width:100%;max-width:16rem;font-size:1.2rem;min-height:3.4rem;border:1px solid rgba(58,40,29,.4);border-radius:0;background:#fff;color:inherit}.mv-upsell__add{min-height:3.8rem;padding:0 1.6rem;font-size:1.1rem;letter-spacing:.18em;text-transform:uppercase;border:1px solid #3a281d;border-radius:0;background:transparent;color:#3a281d;cursor:pointer}.mv-upsell__add:hover{background:#3a281d;color:#fff}.mv-upsell__add:disabled{opacity:.5;cursor:default}.mv-bundle{padding:.6rem 0 1.8rem;background:none;border:0}.mv-bundle__msg{margin:0 0 1.1rem;font-size:1.2rem;letter-spacing:.03em;line-height:1.4;text-align:center}.mv-bundle__steps{position:relative;display:grid;grid-template-columns:repeat(3,1fr);margin:0;padding:0;list-style:none}.mv-bundle__line{position:absolute;top:1.1rem;left:16.66%;right:16.66%;height:1px;background:rgba(58,40,29,.2)}.mv-bundle__line>span{position:absolute;left:0;top:0;bottom:0;background:#3a281d;transition:width .3s ease}.mv-bundle__step{position:relative;display:flex;flex-direction:column;align-items:center;gap:.35rem;text-align:center}.mv-bundle__ico{width:2.3rem;height:2.3rem;display:flex;align-items:center;justify-content:center;border:1px solid rgba(58,40,29,.3);background:#fff;color:#3a281d}.mv-bundle__step.is-on .mv-bundle__ico{background:#3a281d;color:#fff;border-color:#3a281d}.mv-bundle__ico svg{width:1.2rem;height:1.2rem}.mv-bundle__pct{font-size:1.2rem;font-weight:600;letter-spacing:.03em;color:#3a281d;line-height:1.2}.mv-bundle__qty{font-size:1rem;letter-spacing:.12em;text-transform:uppercase;opacity:.65;line-height:1.2}.mv-bundle-pdp{margin:1rem 0 1.4rem;padding:1rem 1.2rem;background:#f4efe9;font-size:1.2rem;letter-spacing:.08em;text-transform:uppercase;line-height:1.7}.mv-bundle-pdp strong{font-weight:600}.mv-sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:90;display:none;align-items:center;gap:1.2rem;padding:1rem 1.6rem calc(1rem + env(safe-area-inset-bottom));background:#fff;border-top:1px solid rgba(58,40,29,.15);transform:translateY(110%);visibility:hidden;transition:transform .25s ease,visibility 0s linear .25s}.mv-sticky-atc.is-visible{transform:none;visibility:visible;transition:transform .25s ease}.mv-sticky-atc__info{flex:1;min-width:0;display:flex;flex-direction:column;gap:.2rem}.mv-sticky-atc__title{font-size:1.2rem;letter-spacing:.1em;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mv-sticky-atc__meta{font-size:1.2rem;opacity:.75;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mv-sticky-atc__btn{flex:0 0 auto;min-width:14rem;min-height:4.4rem;padding:0 2rem}@media(max-width:749px){.mv-sticky-atc{display:flex}body.mv-sticky-on{padding-bottom:7.4rem}}.cart-item:has(a[href*="/products/shipping-protection"]){display:none!important}.mv-protect{display:flex;align-items:center;gap:1rem;margin:0 0 1.2rem;padding:.8rem 1.1rem;border:1px solid rgba(58,40,29,.3);background:#fff;cursor:pointer}.mv-protect__icon{flex:0 0 2rem;width:2rem;height:2rem}.mv-protect__text{flex:1;min-width:0;display:flex;flex-direction:column;gap:.2rem;font-size:1.1rem;line-height:1.35}.mv-protect__text strong{font-weight:600;font-size:1.1rem;letter-spacing:.12em;text-transform:uppercase}.mv-protect__text span{opacity:.75}.mv-protect__price{flex:0 0 auto;font-size:1.2rem}.mv-protect input{position:absolute;opacity:0;width:1px;height:1px}.mv-protect__box{flex:0 0 1.8rem;width:1.8rem;height:1.8rem;border:1px solid #3a281d;display:flex;align-items:center;justify-content:center;color:#fff}.mv-protect__box svg{width:1.2rem;height:1.2rem;opacity:0}.mv-protect input:checked+.mv-protect__box{background:#3a281d}.mv-protect input:checked+.mv-protect__box svg{opacity:1}.mv-protect input:focus-visible+.mv-protect__box{outline:2px solid #3a281d;outline-offset:2px}.mv-protect.is-busy{opacity:.6;pointer-events:none}`;
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  /* ---- aantal echte artikelen: Shipping Protection telt niet mee ---- */
  function realCount(cart) {
    var n = 0;
    cart.items.forEach(function (i) { if (i.handle !== PROTECT_HANDLE) n += i.quantity; });
    return n;
  }
  function fixBubble() {
    var holder = document.getElementById('cart-icon-bubble');
    if (!holder) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var n = realCount(cart);
      var bubble = holder.querySelector('.cart-count-bubble');
      if (!bubble) return;
      if (n < 1) { bubble.style.display = 'none'; return; }
      bubble.style.display = '';
      var a = bubble.querySelector('[aria-hidden]');
      if (a && a.textContent.trim() !== String(n)) a.textContent = n;
      var v = bubble.querySelector('.visually-hidden');
      if (v) {
        var want = n + (n === 1 ? ' item' : ' items');
        if (v.textContent.trim() !== want) v.textContent = want;
      }
    }).catch(function () {});
  }
  function watchBubble() {
    var holder = document.getElementById('cart-icon-bubble');
    if (!holder) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(fixBubble, 60);
    }).observe(holder, { childList: true, subtree: true });
    fixBubble();
  }

  /* ---- alt-tekst fallback: afbeeldingen zonder alt krijgen de productnaam ---- */
  function setAlt(img, text) {
    if (!img || !text) return;
    var a = img.getAttribute('alt');
    if (a === null || a.trim() === '') img.setAttribute('alt', text);
  }
  function fixAlts() {
    document.querySelectorAll('.card-wrapper').forEach(function (c) {
      var h = c.querySelector('.card__heading a') || c.querySelector('.card__heading');
      var title = h ? h.textContent.trim() : '';
      if (!title) return;
      c.querySelectorAll('.card__media img').forEach(function (img) { setAlt(img, title); });
    });
    var pt = document.querySelector('.product__title h1') || document.querySelector('.product__title');
    var ptitle = pt ? pt.textContent.trim() : '';
    if (ptitle) {
      var n = 0;
      document.querySelectorAll('.product__media img').forEach(function (img) { n++; setAlt(img, ptitle + (n > 1 ? ' - image ' + n : '')); });
      document.querySelectorAll('.thumbnail img').forEach(function (img) { setAlt(img, ptitle + ' thumbnail'); });
    }
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var nm = row.querySelector('.cart-item__name');
      var img = row.querySelector('.cart-item__image');
      if (nm && img) setAlt(img, nm.textContent.trim());
    });
  }
  function watchAlts() {
    fixAlts();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(fixAlts, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---- volumekorting: stappen bovenaan het mandje ---- */
  function bundleHtml(n) {
    var cur = null;
    var next = null;
    var curIdx = -1;
    TIERS.forEach(function (t, i) { if (t.qty <= n) { cur = t; curIdx = i; } });
    for (var i = 0; i < TIERS.length; i++) { if (TIERS[i].qty > n) { next = TIERS[i]; break; } }
    var msg;
    if (cur && next) msg = `<strong>${cur.pct}% volume discount applied.</strong> Add ${next.qty - n} more item${next.qty - n > 1 ? 's' : ''} to save ${next.pct}%.`;
    else if (cur) msg = `<strong>${cur.pct}% volume discount applied.</strong> Our best volume price.`;
    else msg = `Add ${TIERS[0].qty - n} more item${TIERS[0].qty - n > 1 ? 's' : ''} and save ${TIERS[0].pct}%.`;
    var steps = TIERS.length - 1;
    var fill = 0;
    if (curIdx >= 0) {
      fill = curIdx / steps;
      if (next) fill += ((n - cur.qty) / (next.qty - cur.qty)) / steps;
    }
    fill = Math.min(1, fill) * 100;
    var items = TIERS.map(function (t) {
      var on = n >= t.qty;
      return `<li class='mv-bundle__step${on ? ' is-on' : ''}'><span class='mv-bundle__ico'>${on ? tick : tagIcon}</span><span class='mv-bundle__pct'>${t.pct}% off</span><span class='mv-bundle__qty'>${t.qty} items</span></li>`;
    }).join('');
    return `<p class='mv-bundle__msg'>${msg}</p><ul class='mv-bundle__steps'><span class='mv-bundle__line'><span style='width:${fill}%'></span></span>${items}</ul>`;
  }
  function decorateBundleDrawer(drawer) {
    if (!bundleOn || drawer.querySelector('.mv-bundle')) return;
    var header = drawer.querySelector('.drawer__header');
    if (!header) return;
    var box = document.createElement('div');
    box.className = 'mv-bundle';
    header.insertAdjacentElement('afterend', box);
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { box.innerHTML = bundleHtml(realCount(c)); }).catch(function () { box.remove(); });
  }
  function decoratePdpBundle() {
    if (!bundleOn || document.querySelector('.mv-bundle-pdp')) return;
    if (document.querySelector('.product__info-container') && /shipping-protection/.test(location.pathname)) return;
    var el = document.createElement('div');
    el.className = 'mv-bundle-pdp';
    el.innerHTML = '<strong>Volume discounts</strong><br>' + TIERS.map(function (t) { return 'Buy ' + t.qty + ' &rarr; ' + t.pct + '% off'; }).join(' &middot; ');
    var qty = document.querySelector('.product__info-container [id^=Quantity-Form]');
    if (qty) { qty.parentNode.insertBefore(el, qty); return; }
    var priceBlock = document.querySelector('.product__info-container [id^=price-]');
    if (priceBlock) priceBlock.insertAdjacentElement('afterend', el);
  }

  /* ---- cart drawer: reassurance notes + upsell ---- */
  var upsellPromise = null;
  var setsPromise = null;
  function getUpsell() {
    if (!upsellPromise) {
      upsellPromise = fetch('/collections/cart-upsell/products.json?limit=30')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return d.products || []; })
        .catch(function () { return []; });
    }
    return upsellPromise;
  }
  function getSets() {
    if (!setsPromise) {
      setsPromise = Promise.all(['women', 'men'].map(function (h) {
        return fetch('/collections/' + h + '/products.json?limit=250')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d) { var o = {}; (d.products || []).forEach(function (p) { o[p.id] = 1; }); return o; })
          .catch(function () { return {}; });
      })).then(function (a) { return { women: a[0], men: a[1] }; });
    }
    return setsPromise;
  }

  function fillUpsell(slot) {
    slot.addEventListener('change', function (e) { e.stopPropagation(); });
    Promise.all([getUpsell(), getSets(), fetch('/cart.js').then(function (r) { return r.json(); })]).then(function (res) {
      var sets = res[1];
      var inCart = {};
      var w = 0;
      var m = 0;
      res[2].items.forEach(function (i) {
        inCart[i.product_id] = 1;
        var iw = sets.women[i.product_id];
        var im = sets.men[i.product_id];
        if (iw && !im) w++;
        else if (im && !iw) m++;
      });
      var target = (w && !m) ? 'women' : ((m && !w) ? 'men' : null);
      var pool = res[0].filter(function (p) {
        return !inCart[p.id] && p.variants.length <= 8 && p.variants.some(function (v) { return v.available; });
      });
      if (target) {
        var matched = pool.filter(function (p) { return sets[target][p.id]; });
        if (matched.length) pool = matched;
      }
      var picks = pool.slice(0, 3);
      if (!picks.length) { slot.remove(); return; }
      var h = `<p class='mv-upsell__title'>Complete your order</p>`;
      picks.forEach(function (p) {
        var av = p.variants.filter(function (v) { return v.available; });
        var img = p.images && p.images[0] ? p.images[0].src : '';
        var imgTag = img ? `<img src='${img}${img.indexOf('?') > -1 ? '&' : '?'}width=160' alt='${p.title.replace(/'/g, '')}' loading='lazy'>` : '';
        var sel = '';
        if (p.variants.length > 1) {
          sel = `<select aria-label='Choose an option'>` + av.map(function (v) { return `<option value='${v.id}'>${v.title}</option>`; }).join('') + `</select>`;
        }
        h += `<div class='mv-upsell__item'><a href='/products/${p.handle}'>${imgTag}</a><div><a class='mv-upsell__name' href='/products/${p.handle}'>${p.title}</a><span class='mv-upsell__price'>${gbp.format(parseFloat(av[0].price))}</span>${sel}</div><button type='button' class='mv-upsell__add' data-mv-upsell-add data-variant-id='${av[0].id}'>Add</button></div>`;
      });
      slot.innerHTML = h;
    }).catch(function () { slot.remove(); });
  }

  /* ---- Shipping Protection: vaste kaart in de lade, standaard UIT, klant kiest zelf ---- */
  var protectPromise = null;
  function getProtect() {
    if (!protectPromise) {
      protectPromise = fetch('/products/' + PROTECT_HANDLE + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          var v = p && p.variants && p.variants[0];
          return v && v.available ? { id: v.id, price: v.price / 100 } : null;
        })
        .catch(function () { return null; });
    }
    return protectPromise;
  }
  function cartCall(url, payload) {
    var drawer = document.querySelector('cart-drawer');
    var body = payload;
    if (body.id !== undefined) body.id = String(body.id);
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        return r.json().then(function (state) {
          if (!r.ok || state.status) throw new Error('cart');
          return state;
        });
      })
      .then(function (state) {
        if (drawer && drawer.renderContents && state.sections) drawer.renderContents(state);
        return state;
      });
  }
  function decorateProtect(footer) {
    if (footer.querySelector('.mv-protect')) return;
    var box = document.createElement('label');
    box.className = 'mv-protect';
    footer.insertBefore(box, footer.firstChild);
    Promise.all([getProtect(), fetch('/cart.js').then(function (r) { return r.json(); })]).then(function (res) {
      var p = res[0];
      var cart = res[1];
      if (!p) { box.remove(); return; }
      var has = cart.items.some(function (i) { return i.variant_id === p.id; });
      var others = cart.items.some(function (i) { return i.variant_id !== p.id; });
      if (!others) {
        box.remove();
        if (has) cartCall('/cart/change.js', { id: p.id, quantity: 0 }).catch(function () {});
        return;
      }
      box.innerHTML = shield + `<span class='mv-protect__text'><strong>Shipping Protection</strong><span>Replacement or refund if your parcel is lost or damaged in transit.</span></span><span class='mv-protect__price'>${gbp.format(p.price)}</span><input type='checkbox' aria-label='Add Shipping Protection'${has ? ' checked' : ''}><span class='mv-protect__box'>${tick}</span>`;
      box.querySelector('input').addEventListener('change', function (e) {
        e.stopPropagation();
        var input = e.target;
        var on = input.checked;
        box.classList.add('is-busy');
        var call = on ? cartCall('/cart/add.js', { items: [{ id: p.id, quantity: 1 }] }) : cartCall('/cart/change.js', { id: p.id, quantity: 0 });
        call.catch(function () { input.checked = !on; }).then(function () { box.classList.remove('is-busy'); });
      });
    }).catch(function () { box.remove(); });
  }

  function decorateDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var items = drawer.querySelector('#CartDrawer-CartItems');
    var footer = drawer.querySelector('.drawer__footer');
    if (!items || !footer || !items.querySelector('.cart-item')) return;
    if (!footer.querySelector('.mv-drawer-notes')) {
      var ul = document.createElement('ul');
      ul.className = 'mv-drawer-notes';
      ul.innerHTML = `<li>${tick}<span>Free UK shipping on your order</span></li><li>${tick}<span>Secure checkout with Klarna, Apple Pay and Google Pay</span></li><li>${tick}<span>Items in your bag are not reserved. Check out to secure yours.</span></li>`;
      footer.insertBefore(ul, footer.firstChild);
    }
    decorateBundleDrawer(drawer);
    decorateProtect(footer);
    if (!items.querySelector('.mv-upsell')) {
      var slot = document.createElement('div');
      slot.className = 'mv-upsell';
      items.appendChild(slot);
      fillUpsell(slot);
    }
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(decorateDrawer, 80);
    }).observe(drawer, { childList: true, subtree: true });
    decorateDrawer();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mv-upsell-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    var item = b.closest('.mv-upsell__item');
    var sel = item && item.querySelector('select');
    var id = Number(sel ? sel.value : b.getAttribute('data-variant-id'));
    var drawer = document.querySelector('cart-drawer');
    var old = b.textContent;
    b.disabled = true;
    b.textContent = 'Adding';
    var body = { items: [{ id: id, quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) { b.disabled = false; b.textContent = old; return; }
        if (drawer && drawer.renderContents && state.sections) drawer.renderContents(state);
        else window.location.href = '/cart';
      })
      .catch(function () { b.disabled = false; b.textContent = old; });
  });

  /* ---- sticky add to cart (mobile): hidden while the main button or the footer is in view ---- */
  function initSticky() {
    var main = document.querySelector('.product__info-container .product-form__submit') || document.querySelector('.product-form__submit');
    if (!main || document.getElementById('mv-sticky-atc') || !('IntersectionObserver' in window)) return;
    var titleEl = document.querySelector('.product__title h1') || document.querySelector('h1');
    var bar = document.createElement('div');
    bar.id = 'mv-sticky-atc';
    bar.className = 'mv-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = `<div class='mv-sticky-atc__info'><span class='mv-sticky-atc__title'></span><span class='mv-sticky-atc__meta'></span></div><button type='button' class='button mv-sticky-atc__btn' tabindex='-1'>Add to cart</button>`;
    document.body.appendChild(bar);
    var past = false;
    var footerInView = false;
    function refresh() {
      var price = document.querySelector('.product__info-container .price-item--last') || document.querySelector('.product__info-container .price-item--regular');
      var opts = [].slice.call(document.querySelectorAll('variant-selects input[type=radio]:checked')).map(function (i) { return i.value; }).join(' / ');
      bar.querySelector('.mv-sticky-atc__title').textContent = titleEl ? titleEl.textContent.trim() : '';
      bar.querySelector('.mv-sticky-atc__meta').textContent = (price ? price.textContent.trim() : '') + (opts ? ' · ' + opts : '');
    }
    function update() {
      var on = past && !footerInView && !main.disabled;
      if (on) refresh();
      bar.classList.toggle('is-visible', on);
      document.body.classList.toggle('mv-sticky-on', on);
    }
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      past = !en.isIntersecting && en.boundingClientRect.top < 0;
      update();
    }, { threshold: 0 }).observe(main);
    var ftr = document.querySelector('footer');
    if (ftr) {
      new IntersectionObserver(function (entries) {
        footerInView = entries[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(ftr);
    }
    bar.querySelector('.mv-sticky-atc__btn').addEventListener('click', function () { main.click(); });
  }

  function init() {
    initSticky();
    decoratePdpBundle();
    watchDrawer();
    watchBubble();
    watchAlts();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
